/* eslint-disable */
import React from 'react';
import classes from './Interpretations.css';
import { Interpretation } from '../Interpretation/Interpretation';

export const Interpretations = props => {
  const { data } = props;
  let interpretationData = ''
  if (data.analysis && data.analysis.length) {
    const d = JSON.parse(data.analysis)
    if(Array.isArray(d)){
      interpretationData = d
    } else {
      interpretationData = d.intervals
    }
  }
  return (
    <div className={classes.interpretations}>
      {interpretationData.length > 0 &&
        interpretationData.map(item => (
          <Interpretation data={item} />
        ))
      }
    </div>
  );
};

export default Interpretations;



// WEBPACK FOOTER //
// ./src/views/components/IDTFRecordingInfoPane/Interpretations/Interpretations.js